import Nav from 'scoreboard/components/nav'
import _ from 'lodash'
import Briefing from './briefing'
import conductor from 'scoreboard/components/conductor'
import Backbone from 'backbone'
import NewTab from 'scoreboard/components/new-tab'
import permissions from 'scoreboard/components/permissions'
import briefer from 'scoreboard/briefings/briefer'
import BriefingsGardener from './briefings-gardener'
import guard from 'scoreboard/components/unsaved/guard'

var BriefingsNav = Nav.extend({

	section: 'briefings',
	changeUrl: false,
	Model: Briefing,
	Gardener: BriefingsGardener,

	events: _.extend({}, Nav.prototype.events, NewTab.events),

	isEditable: function(orgId) {
		return permissions.briefings(orgId)
	},

	onSelect: function(node) {
		this.gardener.finder.clear()
		if (Backbone.history.fragment.indexOf('/new') != -1) {
			// If we're in "add a new object from the display pane" mode,
			// and a tree node was clicked, we can't use changeId because
			// we don't want /new anymore. So do it manually
			conductor.navigate(this.section + '/' + node.id + '/edit', { trigger: true })
		// if currently in edit mode
		} else if (Backbone.history.fragment.indexOf('/edit') != -1) {
			conductor.edit('briefings', node.id)
		} else {
			conductor.overview('briefings', node.id)
		}
	},

	displayNoObjectView: function() {
		Nav.prototype.displayNoObjectView.apply(this, arguments)
		// We're in the briefings nav, but still check if the section is 'briefings'
		// in case we are in spectator mode.
		if (conductor.section() === 'briefings') {
			briefer.toggleBriefingLayout(false)
		}
	},

	// #41921 make sure that the Edit/Done button in the nav pane sends user to
	// the appropriate edit/overview mode for the briefing
	clickEdit: function() {
		let doEdit = () => {
			let isEditing = this.$el.hasClass('is-editing')
			if (isEditing) {
				// if we are currently editing, we are clicking the 'Done' button
				if (Backbone.history.fragment.indexOf('/slide') != -1) {
					// if we are editing a slide, we want to go to view of that
					// slide instead of always back to the beginning of the briefing
					let targetUrl = Backbone.history.fragment
					targetUrl = _.trimEnd(targetUrl, '/edit')
					conductor.navigate(targetUrl, { trigger: true })
				} else {
					// go to briefing overview
					const url = conductor.overviewUrl('briefings', conductor.id())
					this._leaveEditMode(url)
				}
			} else {
				// we are clicking the 'Edit' button, go to briefings edit mode
				conductor.edit('briefings', conductor.id())
			}
			return this.toggleEditViewState(!isEditing)
		}
		if (this.preventGuardOnClickEdit) {
			return doEdit()
		}
		return guard.conditionallyRun(doEdit)
	}
})

_.extend(BriefingsNav.prototype, _.omit(NewTab, 'events'))

export default BriefingsNav

BriefingsNav.__filename__ = 'briefings/briefings-nav.js'
